












































































































































































import { CreateElement, VNode } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
// import { domService } from '../dom-service';
import { SwCheckbox } from '../sw-checkbox';
import { SwIcon } from '../sw-icon';
import SwTable from './sw-table.vue';
import { utilService } from './util.service';
import {
  TableColumnConfig,
  TableBodyMetrics,
  SortedColumnInfo,
} from './types';
import { CSSStyleOptions } from '../common-types';
import { tooltip, TooltipDirValues } from '../tooltip-dir';
// import { domService } from '../dom-service';

interface ColumnTreeDescriptor {
  node: VNode;
  flexMultiplier: number;
  flexBasis: number;
}

const cssPrefix = 'sw-table-header';
const HEADER_CELL_HEIGHT = 28;

@Component({
  components: {
    SwIcon,
    SwCheckbox,
  },
  directives: {
    tooltip,
  },
})
export default class SwTableHeader extends SwExtendedVue {
  @Prop({ type: Array, required: true })
  columnsConfig: TableColumnConfig[];

  @Prop({ type: Array, required: true })
  effectiveColumnsConfig: TableColumnConfig[];

  @Prop({ type: Boolean, required: true })
  columnAdjustable: boolean;

  @Prop({ type: Array, required: true })
  sortedColumns: SortedColumnInfo[];

  @Prop({ type: String, required: true })
  theme: SwTable['theme'];

  @Prop({ type: String, required: true })
  size: SwTable['size'];

  @Prop({ type: Boolean, required: true })
  border: boolean;

  @Prop({ type: Object, required: true })
  bodyMetrics: TableBodyMetrics;

  @Prop({ type: String, required: true })
  selectedStatus: string;

  @Prop({ type: Boolean, default: false })
  forFixedPortion: boolean;

  private cssPrefix = cssPrefix;

  offsetX = 0;

  get depth() {
    function getColDepth(col: TableColumnConfig): number {
      if (!col.children || col.children.length <= 0) { return 1; }
      let max = 0;
      for (const child of col.children) {
        const dep = getColDepth(child);
        if (dep > max) { max = dep; }
      }
      return max + 1;
    }
    return getColDepth({ key: '', children: this.columnsConfig }) - 1;
  }

  get tableStyles(): CSSStyleOptions {
    const styles: CSSStyleOptions = {};
    if (this.forFixedPortion) {
      const width = utilService.calcTableWidth(this.effectiveColumnsConfig);
      styles.width = `${width}px`;
    } else if (this.bodyMetrics.width !== null && this.bodyMetrics.height !== null && this.bodyMetrics.clientHeight !== null) {
      /** this is for using native scrollbar instead of scroll-view for performance */
      // if (this.bodyMetrics.height > this.bodyMetrics.clientHeight) {
      //   const paddingRight = domService.getScrollbarSize();
      //   styles.paddingRight = `${paddingRight}px`;
      //   styles.width = `${this.bodyMetrics.width + paddingRight}px`;
      // } else {
      //   styles.width = `${this.bodyMetrics.width}px`;
      // }
      styles.width = `${this.bodyMetrics.width}px`;
      styles.transform = `translateX(-${this.offsetX}px)`;
    }
    return styles;
  }

  get columnsStyle(): CSSStyleOptions[] {
    return this.effectiveColumnsConfig.map<CSSStyleOptions>((col, index, arr) => {
      return utilService.getColStyles(col, index, arr[index + 1]);
    });
  }

  get leftmostColumns(): TableColumnConfig[] {
    const lcs: TableColumnConfig[] = [];
    let firstCol: TableColumnConfig | null = this.columnsConfig[0];

    while (firstCol) {
      lcs.push(firstCol);
      firstCol = firstCol.children ? firstCol.children[0] : null;
    }

    return lcs;
  }

  get rightmostColumns(): TableColumnConfig[] {
    const rcs: TableColumnConfig[] = [];
    let lastCol: TableColumnConfig | null = this.columnsConfig[this.columnsConfig.length - 1];

    while (lastCol) {
      rcs.push(lastCol);
      lastCol = lastCol.children ? lastCol.children[lastCol.children.length - 1] : null;
    }

    return rcs;
  }

  @Inject()
  readonly claimSelectAllEntries: SwTable['claimSelectAllEntries'];

  @Inject()
  readonly claimSortRequest: SwTable['claimSortRequest'];

  @Inject()
  readonly claimColResizerTrigger: SwTable['claimColResizerTrigger'];

  private isCenteredCell(col: TableColumnConfig) {
    return !!col.children && col.children.length > 0;
  }

  private isTypedCol(col: TableColumnConfig) {
    return !!col.type;
  }

  private isSortableCol(col: TableColumnConfig) {
    return (typeof col.sorter === 'function' || typeof col.sorter === 'boolean');
  }

  private isSortingActive(colKey: string, type: 'asc' | 'desc') {
    const colSortDesc = this.sortedColumns.find(sortDesc => (sortDesc.colKey === colKey));
    if (!colSortDesc) { return false; }
    return colSortDesc.ascending ? (type === 'asc') : (type === 'desc');
  }

  private shouldShowColAdjustHandle(col: TableColumnConfig) {
    return this.columnAdjustable
      && !this.forFixedPortion
      && (!col.children || col.children.length <= 0) // we cannot support adjusting group column width
      && !col.type; // we don't want user to adjust those pre-defined columns
  }

  private getColumnTooltip(col: TableColumnConfig): TooltipDirValues {
    if (col.tooltip) { return col.tooltip; }
    return {
      enabled: false,
      content: '',
    };
  }

  private onChangeSelectStatus(selected: boolean) {
    this.claimSelectAllEntries(selected);
  }

  private requestSortIfNeeded(col: TableColumnConfig) {
    if (!this.isSortableCol(col)) { return; }
    const isActiveAsc = this.isSortingActive(col.key, 'asc');
    const isActiveDesc = this.isSortingActive(col.key, 'desc');
    this.claimSortRequest(col.key, isActiveAsc ? 'cancel' : (isActiveDesc ? 'asc' : 'desc'));
  }

  public updatePosition(pos: { left: number }) {
    // (this.$refs.headerCont as HTMLElement).scrollLeft = pos.left;
    // (this.$refs.headerColsCont as HTMLElement).style.transform = `translateX(-${pos.left}px)`;
    this.offsetX = pos.left;
  }

  private onEnterAdjustHandle(event: MouseEvent, col: TableColumnConfig) {
    this.claimColResizerTrigger({
      col,
      rect: (event.currentTarget as HTMLElement).getBoundingClientRect(),
      colRect: (event.currentTarget as HTMLElement).parentElement!.parentElement!.parentElement!.getBoundingClientRect(),
      // colEl: (event.currentTarget as HTMLElement).parentElement!.parentElement!.parentElement!, // be careful, we are targeting the <th>
    });
  }

  private onLeaveAdjustHandle(event: MouseEvent) {
    this.claimColResizerTrigger({
      rect: null,
      relatedTarget: (event.relatedTarget as HTMLElement),
    });
  }

  private renderColTree(
    h: CreateElement,
    col: TableColumnConfig,
    remainingDepth: number,
    isRightmostCol: boolean,
    isFollowingTypedCol: boolean,
  ): ColumnTreeDescriptor {
    const cellContentNodes: VNode[] = [];
    const childNodes: VNode[] = [];
    const rowNodes: VNode[] = [];
    const sortableCol = this.isSortableCol(col);
    const centeredCell = this.isCenteredCell(col);
    const typedCol = this.isTypedCol(col);
    const cellStyles: CSSStyleOptions = {};
    const colStyles: CSSStyleOptions = {};
    const leafIndex = this.effectiveColumnsConfig.findIndex(c => (c.key === col.key));
    let isBottommost = false;
    let flexMultiplier: number = 0;
    let flexBasis: number = 0;

    /** compose the content for this current cell */
    if (col.type === 'index') {
      cellContentNodes.push(
        <span
          class={[
            `${this.cssPrefix}__col__cell__wrapper__cont__index`,
            { [`${this.cssPrefix}__col__cell__wrapper__cont__index--following`]: leafIndex > 0 },
            'sw-flexbox__flex-none',
          ]}>#</span> as VNode,
      );
    } else if (col.type === 'selection') {
      cellContentNodes.push(
        <span
          class={[
            `${this.cssPrefix}__col__cell__wrapper__cont__selection`,
            { [`${this.cssPrefix}__col__cell__wrapper__cont__selection--following`]: leafIndex > 0 },
            'sw-flexbox__flex-none', 'sw-flexbox', 'sw-flexbox--center-items',
          ]}
        >
          <sw-checkbox
            name={'__check_all__'}
            checked={this.selectedStatus === 'all' ? true : (this.selectedStatus === 'partial' ? 'semi' : false)}
            theme={this.theme}
            on-change={this.onChangeSelectStatus}
          ></sw-checkbox>
        </span> as VNode,
      );
    } else if (col.type === 'expand') {
    } else if (col.type === 'placeholder') {
    } else if (col.type === 'handle') {
    } else {
      cellContentNodes.push(
        <span
          class={[
            `${this.cssPrefix}__col__cell__wrapper__cont__text`,
            { [`${this.cssPrefix}__col__cell__wrapper__cont__text--flex-none`]: centeredCell },
          ]}
        >{ typeof col.title === 'function' ? col.title(h) : col.title }</span> as VNode,
      );
      if (sortableCol) {
        cellContentNodes.push(
          <div
            class={[
              'sw-flexbox__flex-none',
              `${this.cssPrefix}__sorter-wrapper`,
              {
                [`${this.cssPrefix}__sorter-wrapper--active-asc`]: this.isSortingActive(col.key, 'asc'),
                [`${this.cssPrefix}__sorter-wrapper--active-desc`]: this.isSortingActive(col.key, 'desc'),
              },
            ]}
          >
            <sw-icon name="sorting-up" size={14} as-block></sw-icon>
          </div> as VNode,
        );
      }
      if (!centeredCell) {
        cellContentNodes.push(
          <div class={[`${this.cssPrefix}__col__cell__wrapper__cont__fill`]}></div> as VNode,
        );
      }
    }

    if (!col.children || col.children.length <= 0) {
      /** this is the leaf column */
      const style = this.columnsStyle[leafIndex];

      Object.assign(cellStyles, style);
      cellStyles.height = `${remainingDepth * HEADER_CELL_HEIGHT}px`;

      isBottommost = true;

      if (cellStyles.width === 'auto') {
        flexMultiplier = utilService.AUTO_COL_FLEX_MULTIPLIER;
        flexBasis = flexMultiplier;
      } else {
        flexBasis = parseInt(cellStyles.width!, 10);
        if (col.scalable) {
          /** we use the width as the multiplier so now the width will also work as proportion value */
          flexMultiplier = flexBasis;
        }
        if (flexMultiplier !== 0) {
          delete cellStyles.width; // will be using flex-basis to express the width
        }
      }
    } else {
      /** not a leaf, we gather info from children */
      cellStyles.height = `${HEADER_CELL_HEIGHT}px`;

      let prevChildTypedCol = false;
      col.children.forEach((child, index, arr) => {
        const isThisRightmost = isRightmostCol && (index === (arr.length - 1));
        const desc = this.renderColTree(
          h,
          child,
          remainingDepth - 1,
          isThisRightmost,
          (index === 0 && isFollowingTypedCol) || prevChildTypedCol,
        );
        childNodes.push(desc.node);
        flexMultiplier += desc.flexMultiplier;
        flexBasis += desc.flexBasis;
        prevChildTypedCol = this.isTypedCol(child);
      });
    }

    /** first get the cell itself in */
    rowNodes.push(
      <div
        class={[
          `${this.cssPrefix}__col__cell`,
          {
            [`${this.cssPrefix}__col__cell--bottommost`]: isBottommost,
            [`${this.cssPrefix}__col__cell--rightmost`]: isRightmostCol,
            [`${this.cssPrefix}__col__cell--adjustable`]: this.columnAdjustable,
            [`${this.cssPrefix}__col__cell--typed-col`]: typedCol,
            [`${this.cssPrefix}__col__cell--following-typed-col`]: isBottommost && isFollowingTypedCol,
            [`${this.cssPrefix}__col__cell--border`]: this.border,
          },
          col.headerCellClassName || null,
        ]}
        style={cellStyles}
      >
        <div class={[`${this.cssPrefix}__col__cell__wrapper`, 'sw-flexbox']}
          v-tooltip={this.getColumnTooltip(col)}
        >
          <div
            class={[`${this.cssPrefix}__col__cell__wrapper__cont`,
              'sw-flexbox__flex',
              'sw-flexbox', 'sw-flexbox--center-items',
              { 'sw-flexbox--center-justify': centeredCell },
              {
                [`${this.cssPrefix}__col__cell__wrapper__cont--sortable`]: sortableCol,
                // [`${this.cssPrefix}__col__cell__wrapper__cont--${this.size}`]: this.size !== 'normal',
              },
            ]}
            on-click={() => { this.requestSortIfNeeded(col); }}
          >
          { cellContentNodes }
          </div>
          {
            this.shouldShowColAdjustHandle(col) ? (
              <div
                class={[`${this.cssPrefix}__col__cell__wrapper__adjust-handle`, 'sw-flexbox__flex-none']}
              >
                <div
                  class={[
                    `${this.cssPrefix}__col__cell__wrapper__adjust-handle__handle`,
                    { [`${this.cssPrefix}__col__cell__wrapper__adjust-handle__handle--with-border`]: true },
                  ]}
                  on-mouseenter={($event: MouseEvent) => { this.onEnterAdjustHandle($event, col); }}
                  on-mouseleave={this.onLeaveAdjustHandle}
                ></div>
              </div>
            ) : null
          }
        </div>
      </div> as VNode,
    );

    /** then get the children nodes in */
    if (childNodes.length > 0) {
      rowNodes.push(
        <div
          class={[
            `${this.cssPrefix}__col__children`,
            'sw-flexbox',
          ]}
        >
          { childNodes }
        </div> as VNode,
      );
    }

    /** at last, we can wrap everything up */
    if (flexMultiplier === 0) {
      colStyles.flex = 'none';
      colStyles.flexBasis = `${flexBasis}px`;
    } else {
      colStyles.flex = `${flexMultiplier} 0 ${flexBasis}px`;
    }
    return {
      flexBasis,
      flexMultiplier,
      node: (
        <div
          class={[`${this.cssPrefix}__col`]}
          style={colStyles}
        >
          { rowNodes }
        </div>
      ) as VNode,
    };
  }

  private render(h: CreateElement): VNode {
    const colTreeNodes = this.columnsConfig.map<VNode>((col, index, arr) => {
      return this.renderColTree(
        h,
        col,
        this.depth,
        index === (arr.length - 1),
        index > 0 ? this.isTypedCol(arr[index - 1]) : false,
      ).node;
    });

    const rootNode: VNode = (
      <div ref="headerCont" class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.theme}`]}>
        <div ref="headerColsCont" class={[`${this.cssPrefix}__cols`, 'sw-flexbox']} style={[this.tableStyles]}>
          { colTreeNodes }
        </div>
      </div>
    ) as VNode;

    return rootNode;
  }
}
